import assets from './0.3/util/assets';
import { event as logEvent, debug } from './0.3/util/console';
import baseConfig from './0.3/config';
import EventEmitter from './0.3/event/emitter';
import modules from './0.3/module';

const config = baseConfig;

console.log('baseConfig', baseConfig);
console.log('config', config);
const events = new EventEmitter();
const self = {
  $app: events,
  ready: {
    SESSION: false,
    SETUP: false,
    INTERACTIVE: false,
    COMPLETE: false,
    VENDORS: false,
    MODULES: [],
  },
  config,
  beta: config.beta,
  debug: config.debug,
  module: modules,
  modules: [],
  system: {
    currentScript: (typeof (document.currentScript) !== 'undefined') ? document.currentScript : '',
  },
};

const setSessionVars = () => {
  if (!Object.prototype.hasOwnProperty.call(self, 'session')) {
    self.session = {};
  }

  self.session.user = 2;
  self.session.groups = ['Beta'];
  self.session.roles = [];
  self.session.isAdmin = () => self.session.groups.indexOf('Administrator');
  self.session.isBeta = () => self.session.groups.indexOf('Beta');
  self.ready.SESSION = true;
};


const setup = () => {
  debug(`(!) Setting up ${config.APP_NAME} app (DOM Interactive)`);

  // Mask content until ready
  // let loadMask = document.createElement('div');
  // loadMask.setAttribute('style', `position: fixed; width: 100%; height: 100%; left: 0; top: 0; background: ${config.loader.background}; z-index: 9999990; transition: opacity 1s ease-in-out;`);
  // document.body.appendChild(loadMask);
  // self.$app.on('app.defaults.ready', function () {
  //     loadMask.addEventListener("transitionend", function (evt) {
  //         this.remove();
  //     }, false);
  //     loadMask.setAttribute('style', `position: absolute; width: 100%; height: 100%; left: 0; top: 0; background: ${config.loader.background}; z-index: 9999990; transition: opacity 1s ease-in-out; opacity: 0;`);
  // let loadMask = document.createElement('div');
  // loadMask.setAttribute('style', `position: fixed; width: 100%; height: 100%; left: 0; top: 0; background: ${config.loader.background}; z-index: 9999990; transition: opacity 1s ease-in-out;`);
  // document.body.appendChild(loadMask);
  self.$app.on('app.theme.loaded', () => {
    // hook('[HOOK] app.theme.loaded');
    // debug("Transitioning mask start..");
    // loadMask.setAttribute('style', `position: absolute; width: 100%; height: 100%; left: 0; top: 0; background: ${config.loader.background}; z-index: 9999990; transition: opacity 1s ease-in-out; opacity: 0;`);
    // loadMask.addEventListener("transitionEnd", function () {
    //     debug(`(!) transitionend.. remove loading mask`);
    //     this.remove();
    // }, false);
  });

  // Location info, etc.
  self.system = {
    env: 'local',
    device: 'desktop',
  };

  // Get user info
  setSessionVars();

  self.ready.SETUP = true;
};

const start = () => {
  // debug(`(!) Starting ${config.APP_NAME} app (DOM Complete)`);
  // Admin overlays`
  if ((self.session.isAdmin() && self.session.isBeta()) || self.system.env === 'local') {
    const scriptSrc = `${config.paths.scripts}/admin-dev.js${config.debug.cacheBusting ? `?v=${new Date().getTime()}` : ''}`;
    assets(scriptSrc, () => {
      // debug('(!) Admin module loaded');
    });
  }

  // Version check
  {
    const httpRequest = new XMLHttpRequest();
    const versionCheck = () => {
      if (httpRequest.readyState === XMLHttpRequest.DONE) {
        if (httpRequest.status === 200) {
          debug(httpRequest.textContent);
        } else {
          // debug('(!E) Version check failed');
        }
      }
    };

    if (!httpRequest) {
      // debug('Giving up :( Cannot create an XMLHTTP instance');
      return false;
    }
    httpRequest.onreadystatechange = versionCheck;
    httpRequest.open('GET', `${config.paths.build}/versions.json`);
    httpRequest.send();
  }

  if ((self.session.isAdmin() && self.session.isBeta()) || self.system.env === 'local') {
    const scriptSrc = `${config.paths.scripts}/app.js${config.debug.cacheBusting ? `?v=${new Date().getTime()}` : ''}`;
    // debug('%c(!) Loading v0.2.x-dev defaults.js', 'font-weight: bold; color: green');
    // debug(`%c${scriptSrc}`, 'font-weight: bold; color: green');
    assets([scriptSrc, 'module'], () => {
      self.$app.trigger({ type: 'app.dev-defaults.ready' });
      // debug('%c(!) defaults.js-dev onload complete', 'font-weight: bold; color: green');
    });
  } else {
    // @todo use app-dev as an override instead of a full build
    {
      const scriptSrc = `${config.paths.scripts}/app.js${config.debug.cacheBusting ? `?v=${new Date().getTime()}` : ''}`;
      // debug('%c(!) Loading v0.2.x defaults.js', 'font-weight: bold; color: green');
      // debug(`%c${scriptSrc}`, 'font-weight: bold; color: green');
      assets([scriptSrc, 'module'], () => {
        self.$app.trigger({
          type: 'app.defaults.ready',
        });
        // debug('%c(!) defaults.js onload complete', 'font-weight: bold; color: green');
      });
    }
  }

  self.$app.trigger({ type: 'app.ready' });
  // event('[%cEVENT: app.theme.loaded%c] - App theme has loaded', 'color:green', 'color:inherit');
  self.$app.trigger({ type: 'app.theme.loaded' });
  self.ready.COMPLETE = true;

  return true;
};

const init = () => {
  // Make sure setup ran (onreadystatechange probably skipped over interactive)
  // This happens on <script defer></script>
  if (!self.ready.SETUP) {
    setup();
  }

  if (!self.ready.SESSION) {
    // debug('%c(!) Session not ready..', 'color: grey');
    setTimeout(() => {
      init();
    }, 1);
    return false;
  }

  self.ready.INTERACTIVE = true;
  return start();
};

document.onreadystatechange = (evt) => {
  switch (document.readyState) {
    case 'interactive':
      // We can now access the DOM elements
      logEvent(`[%cEVENT: document.onreadystatechange%c] ${document.readyState} - DOM fully loaded and parsed`, 'color:green', 'color:inherit');
      return setup();

    case 'complete':
      logEvent(`[%cEVENT: document.onreadystatechange%c] ${document.readyState} - The page is fully loaded`, 'color:green', 'color:inherit');
      return init();

    // probably "loading"
    default:
      logEvent(`[%cEVENT: document.onreadystatechange%c] DOM readyState ${document.readyState}`, 'color:green', 'color:inherit');
  }

  return evt;
};
{
  document.addEventListener('DOMContentLoaded', (evt) => {
    logEvent(`[%cEVENT: #document.${evt.type}%c] DOM fully loaded and parsed`, 'color:green', 'color:inherit');
  });

  window.addEventListener('load', (evt) => {
    logEvent(`[%cEVENT: ${evt.target.nodeName}.${evt.type}%c] All resources finished loading`, 'color:green', 'color:inherit');
  });

  document.body.onload = (evt) => {
    logEvent(`[%cEVENT: ${evt.target.nodeName}.${evt.type}%c] Body resources finished loading`, 'color:green', 'color:inherit');
  };

  if (typeof (document.fonts) !== 'undefined') {
    document.fonts.ready.then(() => {
      logEvent('[%cEVENT: #document.fonts.ready%c] All fonts in use by visible text have loaded.', 'color:green', 'color:inherit');
    });

    document.fonts.onloadingdone = (evt) => {
      logEvent(`[%cEVENT: #document.fonts.onloadingdone%c] ${evt.fontfaces.length} fonts were loaded`, 'color:green', 'color:inherit');
    };
  }
  const { onload } = document.body;
  document.body.onload = null;
  self.$app.on('app.theme.loaded', onload);
}

if (document.readyState === 'complete') {
  init();
}

export default self;
